import { Component, type OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { SettingsService } from '@odin/odin-settings';
import { CognitoService } from '../../services/cognito-service';

@Component({
  standalone: false,
  selector: 'odin-auth-callback',
  templateUrl: './auth-callback.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./auth-callback.component.scss'],
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private cognitoService: CognitoService,
    private route: ActivatedRoute,
    private router: Router,
    private settingsService: SettingsService,
  ) {}

  ngOnInit(): void {
    this.validateToken();
  }

  private validateToken(): void {
    const minCompleteTime = new Date().getTime() + 1000;
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      const code = params['code'];
      const returnedState = params['state'];

      if (!code) {
        this.router.navigate(['/authentication/login']).then(() => {
          this.cognitoService.loginChanged.emit(false);
        });
        return;
      }

      const expectedState = sessionStorage.getItem('oauth_state');
      sessionStorage.removeItem('oauth_state');

      if (!expectedState || returnedState !== expectedState) {
        this.router.navigate(['/authentication/login']).then(() => {
          this.cognitoService.loginChanged.emit(false);
        });
        return;
      }

      this.cognitoService.getTokenFromCode(code, (success: boolean) => {
        if (!success) {
          this.router.navigate(['/authentication/login']).then(() => {
            this.cognitoService.loginChanged.emit(false);
          });
        } else {
          this.progressSession(minCompleteTime);
        }
      });
    });
  }

  private progressSession(minCompleteTime: number): void {
    let remainingTime = minCompleteTime - new Date().getTime();
    if (remainingTime < 0) remainingTime = 10;
    setTimeout(() => {
      this.cognitoService.CompleteLogin();
      this.router.navigate(['/dashboard']);
    }, remainingTime);
  }
}
